// extracted by mini-css-extract-plugin
export default {"wrapper":"Movie_wrapper__TiH7q","video":"Movie_video__ki2TS","details":"Movie_details__D6x+W","title":"Movie_title__auT19","vote":"Movie_vote__yC9TX"};